import styled from "styled-components/macro";

const FnrOptionCardsContainer = styled("div")`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(137px, 1fr));
  gap: 10px;
`;

export default FnrOptionCardsContainer;
